import Layout from 'components/Layout'
import Loader from 'components/Loader'
import LocationSettings from 'components/RevenueCenters/Form/LocationSettings'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadRevenueCenters } from 'store/RevenueCenters/actions'
import { getIsRevenueCentersLoading } from 'store/RevenueCenters/selector'
import { getCurrentVenueUuid } from 'store/Venues/selector'
import useEmailAuth from 'hooks/useEmailAuth'

const LocationSettingsPage = () => {
  const currenentVenueUuid = useSelector(getCurrentVenueUuid)
  const isLoading = useSelector(getIsRevenueCentersLoading)
  const dispatch = useDispatch()

  const isVenueNexter = useEmailAuth()

  useEffect(() => {
    dispatch(loadRevenueCenters(currenentVenueUuid, isVenueNexter))
  }, [dispatch, currenentVenueUuid])

  if (isLoading) return <Loader />

  return (
    <Layout
      backTo="/reporting-categories"
      mainContent={<LocationSettings />}
      isSidebar
    />
  )
}

export default LocationSettingsPage
